import { SapOdpLinkedServiceAdapter } from 'app/model/adapters/linkedservices/sap-odp-linkedservice.adapter';
import { SapCdcLinkedService } from 'app/model/linkedservice/sap-cdc.linkedservice';
import { AdapterRegistry, IModel, Metamodel } from 'shell-models-lib';

/**
 * @deprecated
 */
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapCdcLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                server: '*',
                systemNumber: '*',
                messageServer: '*',
                messageServerService: '*',
                systemId: '*',
                logonGroup: '*',
                clientId: '*',
                language: '*',
                sncMode: '*',
                sncMyName: '*',
                sncPartnerName: '*',
                sncLibraryPath: '*',
                sncQop: '*',
                userName: '*',
                x509CertificatePath: '*',
                subscriberName: '*',
                password: 'secret',
                encryptedCredential: '*'
            },
            parameter: '*'
        }
    }
})
export class SapCdcLinkedServiceAdapter extends SapOdpLinkedServiceAdapter{
    protected modelConstructor(): new () => SapCdcLinkedService {
        return SapCdcLinkedService;
    }

    protected model(): IModel {
        return SapCdcLinkedService.MODEL;
    }
}
